import script from "./ExpressionItem.js?vue&type=script&lang=js&external"
export * from "./ExpressionItem.js?vue&type=script&lang=js&external"

import "./ExpressionItem.vue?vue&type=style&index=0&id=68e86b11&lang=scss"

const __exports__ = script;

export default __exports__